import { CircumstancesType } from "../../constants";

export interface IProfileForm {
  family_name: string;
  given_name: string;
  email: string;
  profile_nickname: string;
  profile_dob: string;
  profile_gp_details: string;
  profile_support_network: string;
  profile_support_services: string;
  profile_work: string;
  gender: string;
  circumstances: CircumstancesType[];
  profile_university: string;
  profile_course: string;
  profile_contacts: string;
}

export const defaultProfileFormValues: IProfileForm = {
  family_name: "",
  given_name: "",
  email: "",
  profile_nickname: "",
  profile_dob: "",
  profile_gp_details: "",
  profile_support_network: "",
  profile_support_services: "",
  profile_work: "",
  gender: "",
  circumstances: [],
  profile_university: "",
  profile_course: "",
  profile_contacts: "",
};
